import { Box } from '@mui/material'

type CinematicProps = {
  spriteID: string
}

const Cinematic = ({ spriteID }: CinematicProps) => <Box className={`cinematic ${spriteID}`}/>

export default Cinematic
